// VN was hidden after an earlier rollback (see
// docs/GEP-6957-international-account-feasibility-spike.md §2) because its
// Ward/Commune/Province structure didn't fit the flat form and country-region.json's
// province list was stale (pre-2025-reform, 63 entries). Re-enabled as part of
// the Loqate PoC: country-region.json's VN entry now has the current 34
// provincial-level units, City/State field labels reflect Ward/Commune and
// Province terminology, and validateAddress uses Loqate's AVC verification
// status (not the simplified AQI grade, which collapses to "E" for real VN
// matches) to distinguish valid from invalid addresses.
const HIDDEN_COUNTRY_CODES = new Set([])

export const isSelectableCountry = countryCode =>
  !HIDDEN_COUNTRY_CODES.has(String(countryCode || '').toUpperCase())

export const filterSelectableCountries = countries =>
  countries.filter(country =>
    isSelectableCountry(country?.code || country?.isoValue || country?.value),
  )
